import AssistA from './AssistA';
import AssistB from './AssistB';
import AssistC from './AssistC';
import AssistD from './AssistD';
import AssistE from './AssistE';
import AssistF from './AssistF';
import AssistG from './AssistG';
import AssistH from './AssistH';
import AssistI from './AssistI';

const Assist = {
  AssistA,
  AssistB,
  AssistC,
  AssistD,
  AssistE,
  AssistF,
  AssistG,
  AssistH,
  AssistI
};

export default Assist;



// WEBPACK FOOTER //
// ./src/containers/Assist/index.jsx